app.controller('teacherAppIndexCtrl', [
    '$scope', '$rootScope', '$http', function ($scope, $rootScope, $http) {
    }
]);